import React from "react";
import '../../styles/_base.scss'
import { Card, CardBody, Row, Col, Label, Button, Alert, } from "reactstrap";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Select, Textbox } from "react-inputs-validation";
import "../../styles/estilos.css";
import { ambienteAplicacion, urlConsultarCedula } from '../../constants/urls'
import { apiGet } from '../../api'
import { ErrorMsgConstants, infoIds, tipoCotizacion } from '../../constants'
import Select1 from 'react-select';
import makeAnimated from 'react-select/lib/animated';
import LoadingScreen from 'react-loading-screen'
import logo from "assets/img/logo/logo_aig_login-2.png";
import { FetchGirosNegocios, ProvinciasPymesFetch, CoberturasPymesFetch } from "../../redux/actions/aRamoPymes";
import { estaEnListaNegra, isDuplicateHogar, LimpiarListaNegra } from "../../redux/actions/ACarritoProductos";
import { ramos } from "../../utils/constants";

class CotizacionPymes extends React.Component {

  constructor(props) {
    super(props);
    const { ubicaciones = '', codGiroNegocio = '', adicional = '', arraySucursales, datosAsesor, sucursalAsesor } = this.props
    this.state = {
      validate: false,
      ubicacion: ubicaciones ? ubicaciones : 1,
      codGiroNegocio,
      arrayDatosContratante: { cliIdentificacion: '', cliCodigoTipoDocumento: '', cliTipoDocumento: '', cliPersoneria: '', nombres: '', apellidos: '', direccion: '' },
      codigoRamo: -1,
      alert: '',
      esruc: false,
      adicional: adicional ? adicional : '',
      arraySucursales: arraySucursales ? arraySucursales : '',
      sucursalAsesor: sucursalAsesor,

      hasUbicacionError: false,
      hasgiroError: !codGiroNegocio,
      selecadicional: adicional ? true : false,
      hasCedulaError: true,
      hasCodTipoDocError: true,
      hasNombreError: true,
      hasPersoneriaError: true,
      hasAdicionalError: true,
      loading: false,
      hasDireccionError: true,
      nombreProducto:'',
      codigoProducto:'',

    };
  }


  componentDidMount() {
    this.props.limpiarDatosListaNegra()
    // Determinar el codigo de ramo, para el giro de negocio guardado
    if (this.state.codGiroNegocio) {
      this.props.infoPymes.girosNegocio.forEach(item => {
        if (item.giroCodigo === this.state.codGiroNegocio) {
          this.setState({ codigoRamo: item.ramo });
        }
      })
    }

    // set timeout
    setTimeout(() => {
      const { arrayDatosContratante } = this.props
      if (arrayDatosContratante) {
        let esruc = false;
        if (arrayDatosContratante.cliTipoDocumento === 'Ruc') esruc = true

        this.setState({ validate: true, arrayDatosContratante, esruc })
      }
      else {
        this.setState({ validate: true })
      }
    }, 1000);

  }
  tgglevalidate = (validate) => {
    this.setState({ validate });
  }

  // validar y continuar al siguiente paso
  onClick = async () => {
    this.tgglevalidate(true)
    const { ubicacion, codGiroNegocio, hasCedulaError, hasCodTipoDocError, hasNombreError, hasPersoneriaError, hasUbicacionError, hasgiroError, selecadicional, hasAdicionalError, hasDireccionError, nombreProducto, codigoProducto, codigoRamo } = this.state
    let { arrayDatosContratante, adicional, sucursalAsesor } = this.state

    // llamar al servicio de validación de duplicidad
    const checkDuplicidadObj = {
      empresa: "AIGMETROPOLITANA",
      plataforma: 'WEB',
      identificacion: this.state.arrayDatosContratante.cliIdentificacion,
      ramo: this.state.codigoRamo,
    };
    console.log('checkDuplicidadObj pymes', checkDuplicidadObj,);
    await this.props.checkIsDuplicate({ type: 'pymes', postObj: checkDuplicidadObj });

    const datosAsesor = {

      sucursalSeleccionada: this.props.datosSucursales
        .sucursalSelecionadaAsesor,

      ambiente: ambienteAplicacion,
      emailAsesor: this.props.datosUsuarios.correo
        ? this.props.datosUsuarios.correo
        : "",
      nombreProducto: nombreProducto,
      codigoProducto: codigoProducto,
      codigoRamo: codigoRamo,
      nombreRamo: ramos.PYMES.nombre,
      codGiroNegocio: codGiroNegocio,

    }

    await this.props.checkInListaNegra(this.state.arrayDatosContratante.cliIdentificacion, datosAsesor)

    // validar si existe duplicidad o errores antes de continuar
    if (this.props.duplicity.isDuplicatePoliza === false) {
      if (this.props.datosListaNegra.inListaNegra === false) {

        if (!hasCedulaError && !hasCodTipoDocError && !hasNombreError && !hasPersoneriaError && !hasUbicacionError && !hasgiroError && !(selecadicional && hasAdicionalError) && !hasDireccionError && !this.props.duplicity.duplicidadPolizaError) {
          const { listaIdentificacion } = this.props
          const { name } = listaIdentificacion.find(({ id }) => id === arrayDatosContratante.cliCodigoTipoDocumento)
          arrayDatosContratante.cliTipoDocumento = name
          arrayDatosContratante.apellidos = arrayDatosContratante.apellidos.trim()
          arrayDatosContratante.direccion = arrayDatosContratante.direccion.trim()
          arrayDatosContratante.nombres = arrayDatosContratante.nombres.trim()
  
          this.props.handleNext({ ubicaciones: ubicacion, codGiroNegocio, visible: 2, arrayDatosContratante, adicional, sucursalAsesor })

         
        }
        else {
          this.setState({ alert: 'Complete todos los campos' })
        } 


        
  

      }

    }
  }

  getTipoDocumentos(personeria) {
    const { listaIdentificacion } = this.props
    let listado = listaIdentificacion.filter((tipo) => (parseInt(tipo.personeria) === parseInt(personeria) || !tipo.personeria))
    return listado;
  }
  consultaCargarDatos = async params => {
    const { cedula, tipo } = params;
    const data = await apiGet(urlConsultarCedula + cedula)
    console.log("DATA", data)
    const { razon_social = '', apellido1 = '', apellido2 = '', nombre1 = '', nombre2 = '', direcciones = '', direccion = '' } = data
    if (cedula.length === 13)
      this.setState(prevState => ({ arrayDatosContratante: { ...prevState.arrayDatosContratante, nombres: `${razon_social ? razon_social : ""} `, apellidos: `${razon_social ? razon_social : ""}`, direccion: `${direccion ? direccion : ''}` }, validate: false, loading: false }))
    else
      this.setState(prevState => ({ arrayDatosContratante: { ...prevState.arrayDatosContratante, nombres: `${nombre1 ? nombre1 : ""} ${nombre2 ? nombre2 : ""}`, apellidos: `${apellido1 ? apellido1 : ""} ${apellido2 ? apellido2 : ""}`, direccion: `${direcciones ? direcciones : ''}` }, validate: false, loading: false }))
    setTimeout(() => this.setState({ validate: true }), 100)

  }
  componentDidUpdate(prevProps, prevState) {
    const { ubicaciones, codGiroNegocio, arrayDatosContratante } = this.props

    if (ubicaciones !== prevProps.ubicaciones || codGiroNegocio !== prevProps.codGiroNegocio) {
      let adicional = this.props.data.find(item => item.giroCodigo === codGiroNegocio).adicional
      this.setState({ ubicacion: ubicaciones, codGiroNegocio, adicional })
    }
    if (arrayDatosContratante !== prevProps.arrayDatosContratante || arrayDatosContratante !== prevProps.arrayDatosContratante) this.setState({ arrayDatosContratante })

    if (this.state.codGiroNegocio !== prevState.codGiroNegocio) {
      if (this.state.codGiroNegocio)
        this.setState({ hasgiroError: false })
      else this.setState({ hasgiroError: true })
    }

    if (prevProps.arrayDatosContratante !== this.props.arrayDatosContratante && this.props.arrayDatosContratante !== this.state.arrayDatosContratante) {
      let esruc = false;
      if (this.props.arrayDatosContratante.cliTipoDocumento === 'Ruc') esruc = true

      this.setState({ validate: true, arrayDatosContratante, esruc })
    }

  }

  consultarCoberturas = async (giroNegocio) => {

    console.log('select1change ', giroNegocio)


    await this.props.CoberturasPymesFetch({ giroNegocio: giroNegocio })



  }

  //ubicaciones gironegocio
  render() {

    console.log(this.state)

    const { loading, validate, ubicacion, codGiroNegocio, alert, arrayDatosContratante, esruc, adicional, selecadicional, sucursalAsesor } = this.state;
    const { data2 } = this.props
    let { listaPersoneria, arraySucursales } = this.props
    const { cliIdentificacion, cliCodigoTipoDocumento, cliPersoneria, nombres, apellidos, direccion } = arrayDatosContratante
    let defaulGiro = data2.filter(item => item.value === codGiroNegocio)

    return (
      <LoadingScreen
      loading={loading || this.props.duplicity.duplicidadPolizaLoading}
        bgColor="#f1f1f1"
        spinnerColor="#001871"
        textColor="#676767"
        logoSrc={logo}
        text="Cargando..."
      >
        <Row className='container-body-spaces'>
          <Col lg={10} className="div-align-center">
            <Card className="flex-row ">
              <CardBody>

                <Row>
                  <Col lg={4} md={4} sm={4} >
                    <h5>Seleccione la personería(*)</h5>
                  </Col>
                  <Col lg={8} md={8} sm={8} >
                    <Select
                      //tabIndex="6" // Optional.[String or Number].Default: none.
                      id={"personeria"} // Optional.[String].Default: "". Input ID.
                      name={"personeria"} // Optional.[String].Default: "". Input name.
                      value={cliPersoneria} // Optional.[String].Default: "".
                      validate={validate}
                      optionList={listaPersoneria} // Required.[Array of Object(s)].Default: [].
                      onChange={(cliPersoneria, e) => {
                        this.setState(prevState => ({ arrayDatosContratante: { ...prevState.arrayDatosContratante, cliPersoneria, cliCodigoTipoDocumento: '', nombres: '', apellidos: '' }, hasPersoneriaError: cliPersoneria ? false : true }))
                      }
                      }
                      onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                      customStyleOptionListContainer={{}} // Optional.[Object].Default: {}.
                      validationCallback={res => this.setState({ hasPersoneriaError: res, validate: false })}
                      validationOption={{
                        name: "personeria", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                        check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                        required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                        msgOnError: "Por favor seleccione la personería"
                      }}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col lg={4} md={4} sm={4} >
                    <h5>Seleccione tipo de documento(*)</h5>
                  </Col>
                  <Col lg={8} md={8} sm={8} >
                    <Select
                      //tabIndex="6" // Optional.[String or Number].Default: none.
                      id={"selectTipoDoc"} // Optional.[String].Default: "". Input ID.
                      name={"selectTipoDoc"} // Optional.[String].Default: "". Input name.
                      value={cliCodigoTipoDocumento} // Optional.[String].Default: "".
                      validate={validate}
                      optionList={this.getTipoDocumentos(cliPersoneria)} // Required.[Array of Object(s)].Default: [].
                      onChange={(cliCodigoTipoDocumento) => this.setState(prevState => ({
                        arrayDatosContratante: { ...prevState.arrayDatosContratante, cliPersoneria, cliCodigoTipoDocumento },
                        esPasaporte: cliCodigoTipoDocumento === infoIds.codigoPasaporteStr ? true : false, esruc: cliCodigoTipoDocumento === infoIds.codigoRucStr ? true : false,
                        hasCodTipoDocError: cliCodigoTipoDocumento ? false : true,
                      }))}
                      // Optional.[Func].Default: () => {}. Will return the value.
                      onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                      //customStyleOptionListContainer={{}} // Optional.[Object].Default: {}.
                      validationCallback={res => this.setState({ hasCodTipoDocError: res, validate: false })}
                      validationOption={{
                        name: "selectTipoDoc", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                        check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                        required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                        msgOnError: "Por favor seleccione el tipo de documento"
                      }}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col lg={4} md={4} sm={4} >
                    <h5>Número de Identificación (*)</h5>
                  </Col>
                  <Col lg={8} md={8} sm={8} >
                    <Textbox
                      tabIndex="1"
                      type="text"
                      id="cedula"
                      name="cedula"
                      classNameInput={"form-control"}
                      value={cliIdentificacion}
                      validate={validate}
                      onChange={(cliIdentificacion, e) => {
                        this.setState(prevState => ({ arrayDatosContratante: { ...prevState.arrayDatosContratante, cliPersoneria, cliIdentificacion } }))
                        if ((this.state.esruc && (cliIdentificacion.length === 13 && cliCodigoTipoDocumento === infoIds.codigoRucStr)) || (!this.state.esruc && (cliIdentificacion.length === 10 && cliCodigoTipoDocumento === infoIds.codigoCedulaStr))) {
                          this.setState({ loading: true })
                          this.consultaCargarDatos({ cedula: cliIdentificacion, tipo: 1 })
                        }
                      }}
                      onBlur={() => { }}
                      validationCallback={res => this.setState({ hasCedulaError: res, validate: false })}
                      validationOption={{
                        name: "cedula", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                        check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                        required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                        reg: this.state.esruc ? /^\d{13}$/ : this.state.esPasaporte ? '' : /^\d{10}$/,
                        msgOnError: "Por favor ingrese la identificación correctamente"
                      }}

                    />
                  </Col>
                </Row>
                <Row>
                  <Col lg={4} md={4} sm={4} >
                    <h5>{cliCodigoTipoDocumento !== infoIds.codigoRucStr ? "Nombres (*)" : "Razón Social (*)"}</h5>
                  </Col>
                  <Col lg={8} md={8} sm={8} >
                    <Textbox
                      type="text"
                      id="nombres"
                      name="nombres"
                      validate={validate}
                      classNameInput={"form-control"}
                      value={nombres}
                      onChange={(nombres, e) => this.setState(prevState => ({ arrayDatosContratante: { ...prevState.arrayDatosContratante, nombres: nombres.trimStart() } }))}
                      onBlur={() => { }}
                      validationCallback={res => this.setState({ hasNombreError: res, validate: false })}
                      validationOption={{
                        name: "nombres", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                        check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                        reg: cliCodigoTipoDocumento !== infoIds.codigoPasaporteStr ? /^[\u00e1\u00e9\u00ed\u00f3\u00fa\u00c1\u00c9\u00cd\u00d3\u00da\u00f1\u00d1A-Za-z0-9 _]*$/ : /^[\u00e1\u00e9\u00ed\u00f3\u00fa\u00c1\u00c9\u00cd\u00d3\u00da\u00f1\u00d1A-Za-z0-9. _]*$/,
                        required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                        msgOnError: "Por favor ingrese los nombres, No deben tener caracteres especiales"
                      }}
                    />
                  </Col>
                </Row>

                {!esruc &&
                  <Row>
                    <Col lg={4} md={4} sm={4} >
                      <h5>Apellidos (*)</h5>
                    </Col>
                    <Col lg={8} md={8} sm={8} >
                      <Textbox
                        type="text"
                        id="apellidos"
                        name="apellidos"
                        validate={validate}
                        classNameInput={"form-control"}
                        value={apellidos}
                        onChange={(apellidos, e) => this.setState(prevState => ({ arrayDatosContratante: { ...prevState.arrayDatosContratante, apellidos: apellidos.trimStart() } }))}
                        onBlur={() => { }}
                        validationCallback={res => this.setState({ hasNombreError: res, validate: false })}
                        validationOption={{
                          name: "apellidos", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                          check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                          reg: /^[\u00e1\u00e9\u00ed\u00f3\u00fa\u00c1\u00c9\u00cd\u00d3\u00da\u00f1\u00d1A-Za-z _]*$/,
                          required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                          msgOnError: "Por favor ingrese los apellidos, No deben tener caracteres especiales"
                        }}
                      />
                    </Col>
                  </Row>
                }
                <Row>
                  <Col lg={4} md={4} sm={4} >
                    <h5>{"Dirección"}</h5>
                  </Col>
                  <Col lg={8} md={8} sm={8} >
                    <Textbox
                      type="text"
                      id="direccion"
                      name="direccion"
                      validate={validate}
                      classNameInput={"form-control"}
                      value={direccion}
                      onChange={(direccion, e) => this.setState(prevState => ({ arrayDatosContratante: { ...prevState.arrayDatosContratante, direccion: direccion.trimStart() } }))}
                      onBlur={() => { }}
                      validationCallback={res => this.setState({ hasDireccionError: res, validate: false })}
                      validationOption={{
                        name: "direccion", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                        check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                        //reg: /^[\u00e1\u00e9\u00ed\u00f3\u00fa\u00c1\u00c9\u00cd\u00d3\u00da\u00f1\u00d1A-Za-z _]*$/,
                        required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                        msgOnError: "Por favor ingrese una dirección."
                      }}
                    />
                  </Col>
                </Row>


                <Row className="mb-3">
                  <Col md={4}  >
                    <h5><Label className="bold-font-label" > Giro del negocio </Label></h5>
                  </Col>
                  <Col md={8} >

                    <Select1
                      value={defaulGiro}
                      //defaultValue={defaulGiro}
                      components={makeAnimated()}
                      onChange={
                        ({ adicional, label, value, codRamo, codigoProducto, nombreProducto }, e) => {
                          console.log('Testingdavidm');
                          this.props.FetchGirosNegocios(); this.consultarCoberturas(value);
                          console.log('typeof(data2)', typeof (data2), data2);

                   

                          this.setState({ codigoProducto: codigoProducto,codRamo: codRamo, nombreProducto: nombreProducto, codGiroNegocio: value, giroNombre: label, selecadicional: adicional, codigoRamo: codRamo, hasgiroError: value ? false : true })



                        }


                      }
                      options={data2}
                      isSearchable={true}
                      placeholder={"Seleccione una opción"}
                      isMulti={false}
                    />
                    {!codGiroNegocio &&
                      <span style={{ color: '#FA5A77', fontSize: 14, }} >Por favor seleccione un giro de negocio</span>}
                    {/* <Select
                    tabIndex="4" // Optional.[String or Number].Default: none.
                    id={"selectNegocio"} // Optional.[String].Default: "". Input ID.
                    name={"selectNegocio"} // Optional.[String].Default: "". Input name.
                    value={codGiroNegocio} // Optional.[String].Default: "".
                    optionList={data} // Required.[Array of Object(s)].Default: [].
                    validate={validate}
                    validationCallback={res => this.setState({ hasgiroError: res, validate: !res })} // Optional.[Func].Default: none. Return the validation result.
                    //onChange={(negocioSeleccionado, e) => this.setState({ negocioSeleccionado, formEditado: true })}
                    selectHtml={<div>{giroNombre}</div>} //Optional.[Html].Default: none. The custom html that will display when user choose. Use it if you think the default html is ugly.
                    selectOptionListItemHtml={data.map(({ giroCodigo, giroNombre, adicional }, k) =>
                      <div key={k} className='selectCustom'
                        onClick={() => this.setState({ codGiroNegocio: giroCodigo, giroNombre, selecadicional: adicional })} >{giroNombre}</div>
                    )}
                    onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                    customStyleOptionListContainer={{}} // Optional.[Object].Default: {}.
                    validationOption={{
                      name: "selectNegocio", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                      check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                      required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                      msgOnError: "Por favor seleccione un giro de negocio"
                    }}
                  /> */}

                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col lg={4} md={4}  >
                    <h5 style={{ margin: 0, }}><Label className="bold-font-label" >Ubicaciones</Label></h5>
                    <p style={{}} >Número de locales a asegurar </p>
                  </Col>
                  <Col lg={7} md={7} >

                    <Textbox
                      tabIndex="1"
                      type="number"
                      value={ubicacion}
                      name="ubicacion"
                      id="ubicacion"
                      classNameInput={"form-control"}
                      onChange={(ubicacion, e) => {
                        ubicacion = parseInt(ubicacion)
                        if (ubicacion > 0) this.setState({ ubicacion, hasUbicacionError: false });
                      }}

                      validationCallback={res => this.setState({ hasUbicacionError: res, validate: false })} // Optional.[Func].Default: none. Return the validation result.
                      onBlur={() => { }}
                      validationOption={{
                        name: "ubicaciones", // Optional.[String].Default: "". To display in the Error message. i.e Please enter your ${name}.
                        check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                        required: true,
                        reg: /^[1-9]\d*$/, //Optional.[Bool].Default: "" Custom regex.
                        msgOnError: "Por favor ingrese el número de locales" // Optional.[Bool].Default: true. To determin if it is a required field.
                      }}
                    />
                  </Col>

                </Row>


                {selecadicional &&
                  <Row className="mb-3">
                    <Col lg={4} md={4}  >
                      <h5><Label className="bold-font-label" >Tipo de cotización</Label></h5>
                    </Col>
                    <Col lg={7} md={7} >

                      <Select
                        tabIndex="7" // Optional.[String or Number].Default: none.
                        id={"tipoCotizacion"} // Optional.[String].Default: "". Input ID.
                        name={"tipoCotizacion"} // Optional.[String].Default: "". Input name.
                        value={adicional} // Optional.[String].Default: "".
                        optionList={tipoCotizacion} // Required.[Array of Object(s)].Default: [].
                        validate={validate}
                        validationCallback={res => this.setState({ hasAdicionalError: res, validate: false })} // Optional.[Func].Default: none. Return the validation result.
                        onChange={(adicional, e) => this.setState({ adicional })}
                        onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                        //customStyleOptionListContainer={{}} // Optional.[Object].Default: {}.
                        validationOption={{
                          name: "selecCotizacion", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                          check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                          required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                          msgOnError: "Por favor seleccione el tipo de cotización"
                        }}
                      />

                    </Col>
                  </Row>
                }

                {this.props.datosAsesor && this.props.datosAsesor.usu_tipo_usuario !== 'cliente' &&
                  <Row>
                    <Col lg={4} md={4} sm={12} xs={12}><h5><Label for="exampleSelect" className="bold-font-label" >Sucursal de Emisión</Label></h5></Col>
                    <Col lg={7} md={7} sm={12} xs={12}>
                      <Select
                        tabIndex="6" // Optional.[String or Number].Default: none.
                        id={"SelectSucursal"} // Optional.[String].Default: "". Input ID.
                        name={"SelectSucursal"} // Optional.[String].Default: "". Input name.
                        value={sucursalAsesor} // Optional.[String].Default: "".
                        optionList={arraySucursales} // Required.[Array of Object(s)].Default: [].
                        onChange={(selec, e) => {
                          //console.log(selec);                                                 
                          this.setState({ sucursalAsesor: selec });
                        }}
                        validate={validate}
                        validationCallback={res =>
                          //console.log(res) 
                          this.setState({
                            hasCiudadError: res,
                            validate: !res
                          })
                        }
                        // Optional.[Func].Default: () => {}. Will return the value.
                        onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                        customStyleOptionListContainer={{}} // Optional.[Object].Default: {}.
                        validationOption={{
                          name: "SelectCiudad", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                          check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                          required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                          msgOnError: "Por favor seleccione una sucursal"
                        }}
                      />
                    </Col>
                  </Row>
                }

                <Row>
                  <div className="div-align-rigth">
                    <Button className="btn btn-primary" onClick={() => this.onClick()} style={{ display: "block", margin: "auto" }}>
                      <i className="fa fa-chevron-circle-right" aria-hidden="true" />{"  CONTINUAR"}
                    </Button>
                  </div>
                </Row>

                {/* Mensaje de error*/}
                <div style={{ marginTop: '2rem' }}>
                  {/* Validacion de duplicidad */}
                  {console.log('test dup msg', this.props.duplicity)}
                  {this.props.duplicity.isDuplicatePoliza
                    ?
                    <Alert color="danger">
                      <center><p>{ErrorMsgConstants.duplicidad}</p></center>
                    </Alert>
                    :
                    null
                  }
                  {this.props.duplicity.duplicidadPolizaError &&
                    <Alert color="danger">
                      <center><p>{ErrorMsgConstants.errorServicioDuplicidad}</p></center>
                    </Alert>
                  }
                </div>

                <div style={{ marginTop: '2rem' }}>
                  {/* Validacion de duplicidad */}
                  {console.log('test dup msg', this.props.datosListaNegra)}
                  {this.props.datosListaNegra.inListaNegra
                    ?
                    <Alert color="danger">
                      <center><p>{this.props.datosListaNegra.inListaNegraMensaje}</p></center>
                    </Alert>
                    :
                    null
                  }
                  {this.props.datosListaNegra.listaNegraError &&
                    <Alert color="danger">
                      <center><p>{ErrorMsgConstants.errorServicioListaNegra}</p></center>
                    </Alert>
                  }
                </div>
              </CardBody>

            </Card>
          </Col>
        </Row >
      </LoadingScreen>
    );
  }
}

// const mapStateToProps = state => ({
//   listaPersoneria: state.catalogosCotizacion.personeria.tiposPersoneria,
//   data: state.dataPymes.girosNegocio,
//   //data2: state.dataPymes.girosNegocio.forEach(({ giroNombre, giroCodigo, adicional }, i) => this[i] = { label: giroNombre, value: giroCodigo, adicional }, state.dataPymes.girosNegocio),
//   listaIdentificacion: state.catalogosCotizacion.personeria.tiposIdentificacion
// });

const mapStateToProps = state => {

  let data2 = []
  const data = state.dataPymes.girosNegocio
  if (data && data.length > 0)
    data.forEach(({ giroNombre, giroCodigo, adicional, ramo, codigoProducto, nombreProducto }, i) => data2.push({ label: giroNombre, value: giroCodigo, adicional: adicional, codRamo: ramo, codigoProducto, nombreProducto  }))


  return {
    data,
    data2,
    listaPersoneria: state.catalogosCotizacion.personeria.tiposPersoneria,
    listaIdentificacion: state.catalogosCotizacion.personeria.tiposIdentificacion,
    duplicity: state.datosDuplicidadPolizas,
    datosListaNegra: state.datosListaNegra,
    infoPymes: state.dataPymes,
    datosUsuarios: state.datosUsuarios.dataUsuario,
    datosSucursales: state.datosSucursales
  }
}

const mapDispatchToProps = dispatch => ({
  FetchGirosNegocios: () => dispatch(FetchGirosNegocios()),
  ProvinciasPymesFetch: () => dispatch(ProvinciasPymesFetch()),
  CoberturasPymesFetch: (data) => dispatch(CoberturasPymesFetch(data)),
  checkIsDuplicate: (datosCheckDuplicity) => dispatch(isDuplicateHogar(datosCheckDuplicity)),
  checkInListaNegra: (identificacion, datos) => dispatch(estaEnListaNegra(identificacion, datos)),
  limpiarDatosListaNegra: () => dispatch(LimpiarListaNegra()),
})

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps, // null
  )(CotizacionPymes)
);
